// eslint-disable-next-line import/no-named-as-default
import fetch from 'utils/fetch'
import routes from 'config/routes'
import { endpoint } from '@library/endpoint'

export function buildSubscriptionCommandUrl(userId, path = '') {
  return `${endpoint('subscriptioncommand')}/subscriptions/${userId}${path}`
}

export function buildSubscriptionQueryUrl(userId, path) {
  return `${endpoint(
    'subscriptionquery'
  )}${path}/${userId}`
}

export function skipDates(accessToken, userId, dates) {
  return fetch(
    accessToken,
    `${buildSubscriptionCommandUrl(userId, routes.subscriptionCommand.skip)}`,
    {
      skipDates: dates,
    },
    'POST',
    'default',
    {'Content-Type': 'application/json'}
  )
}

export function unSkipDates(accessToken, userId, dates) {
  return fetch(
    accessToken,
    `${buildSubscriptionCommandUrl(userId, routes.subscriptionCommand.unSkip)}`,
    {
      unskipDates: dates,
    },
    'POST',
    'default',
    {'Content-Type': 'application/json'}
  )
}

export function fetchSubscription(accessToken, userId) {
  return fetch(
    accessToken,
    buildSubscriptionQueryUrl(userId, routes.subscriptionQuery.subscriptions),
    {},
    'GET',
  )
}

export function fetchProjectedDeliveries(accessToken, userId) {
  return fetch(
    accessToken,
    `${buildSubscriptionQueryUrl(userId, routes.subscriptionQuery.projectedDeliveries)}`,
    {},
    'GET',
  )
}

export function deactivateSubscription(accessToken, pauseDate, userId) {
  return fetch(
    accessToken,
    `${buildSubscriptionCommandUrl(userId, routes.subscriptionCommand.deactivate)}`,
    { pauseDate },
    'POST',
    'default',
    {'Content-Type': 'application/json'}
  )
}

export function getPauseReasons() {
  return {
    reasons: [
      { label: "I can't afford a weekly box", value: "I can't afford a weekly box" },
      { label: "I'm going away", value: "I'm going away" },
      { label: "I'm using a different recipe box brand instead", value: "I'm using a different recipe box brand instead" },
      { label: "The menu doesn't have enough variety for me", value: "The menu doesn't have enough variety for me" },
      { label: "I don't want to be on a subscription", value: "I don't want to be on a subscription" },
      { label: 'I had a problem', value: 'I had a problem' },
      { label: 'Something else', value: 'Something else' },
    ],
  }
}
